<mat-card class="selection-section">
    <div class="panel_sub_header">
        <span class="panel__header__title">   {{"Select Additional Observation Level" | translate | async}}</span>
    </div>
  <div class="radio-button-observation-level">
      <mat-radio-group  [(ngModel)]=" addObservationListAgainst"  ngDefaultControl required >
          <mat-radio-button class="radio-buttons" [value]="0" >
              {{  "Customer" | translate | async }}
          </mat-radio-button>
          <mat-radio-button class="radio-buttons" [value]="1"  >
              {{  "Model" | translate | async }}
          </mat-radio-button>
          <mat-radio-button class="radio-buttons" [value]="2" >
              {{  "Family" | translate | async }}
          </mat-radio-button>
        </mat-radio-group>
  </div>
</mat-card>
<mat-card class = "level-filter">
    <div class="panel_sub_header">
        <span class="panel__header__title"> {{"Additional Observation Constraint Filter" | translate | async}}</span>
    </div>
    <div class="select-observation-against">
        <div *ngIf="addObservationListAgainst === 0"   class="filter-select">
        <!-- {{  "Againest Customer" | translate | async }} -->
        <mat-form-field  class="filter-select">
          <mat-select  [(ngModel)]="_currentSelection.customer" (selectionChange)="selectedAgainstCustomer($event)" placeholder="{{ Translate('Customer') }}">
              <mat-option *ngFor="let customer of customerList" [value]="customer">
                  {{ customer.Name }}
              </mat-option>
          </mat-select>
          </mat-form-field>
        </div>
        <div *ngIf="addObservationListAgainst === 1"  class="filter-select">
            <!-- {{  "Againest Model" | translate | async }} -->
            <mat-form-field   class="filter-select">
              <mat-select  [(ngModel)]="_currentSelection.make" (selectionChange)="makeChanged($event)" placeholder="{{ Translate('Make') }}">
                  <mat-option *ngFor="let make of _dropDownListsFiltered.makeList" [value]="make">
                      {{ make.Title }}
                  </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field  class="filter-select">
              <mat-select  [(ngModel)]="_currentSelection.model" (selectionChange)="selectedAgainstModel($event)"  placeholder="{{ Translate('Model') }}">
                  <mat-option *ngFor="let model of _dropDownListsFiltered.modelList" [value]="model">
                      {{ model.Title }}
                  </mat-option>
              </mat-select>
            </mat-form-field>
        </div>
        <div *ngIf="addObservationListAgainst === 2"  class="filter-select">
        <!-- {{  "Againest Family" | translate | async }} -->
            <mat-form-field  class="filter-select">
              <mat-select  [(ngModel)]="_currentSelection.family" (selectionChange)="selectedAgainstFamily($event)" placeholder="{{ Translate('Family') }}">
                  <mat-option *ngFor="let family of _dropDownLists.familyList" [value]="family">
                      {{ family.Title }}
                  </mat-option>
              </mat-select>
            </mat-form-field>
        </div>
        <!-- <div>
          <button (disabled)="selectAgainstIsVaild()" >TestVaildation</button>
        </div> -->
      </div>
</mat-card>


<mat-card  *ngIf="selected" class = "observation-list-table">
  <div>
      <div *ngIf="addObservationListAgainst === 0">
          <div class="panel_sub_header">
              <span class="panel__header__title"> {{"Additional Observation List On Customer" | translate | async}}</span>
              <span class="panel__header__title"> {{selectedCustomer?.Name}}</span>
          </div>
            <panel class="no-padding table-panel">
              <!-- <div class="spinner">
                <mat-spinner diameter="30"></mat-spinner>
              </div> -->
              <table class="table table--full-width table--striped table--hover" >
                <thead>
                  <tr>
                    <th >{{'Title' | translate | async}}</th>
                    <th>{{'Type' | translate | async}}</th>
                    <th>{{'Answer' | translate | async}}</th>
                    <th>{{'Disabled' | translate | async}}</th>
                    <th>{{'Edit' | translate | async}}</th>
                    <th><button mat-raised-button color="warn" (click)="addNewObservationListOnCustomer()"> <i  class="material-icons">add</i> {{"Add New" | translate | async}} </button></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let model of customerLevelObservationList">
                    <td>  <div> {{ model.Title }} </div></td>
                    <td>  <div> {{ model.QuestionTypeName }} </div></td>
                    <td>  <div style="flex:1;display: flex;flex-direction: column;justify-content: center;">
                        <div *ngIf="model.QuestionTypeId == 1 ||model.QuestionTypeId == 2 || model.QuestionTypeId == 3 || model.QuestionTypeId == 5" style="flex:1;display: flex">
                          <i (click)="onClickEditAnswer(model)" class="material-icons button__icon"
                            style="color:black;cursor: pointer;">comment</i>
                        </div>
                      </div></td>
                    <td> <div> {{model.Disabled ? "Disabled" : "Active"}} </div></td>
                    <td> <div>  <button mat-stroked-button color="primary" (click)="editObservation(model)" > {{"Edit Observation" | translate | async}}</button> </div></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </panel>
          </div>

        <div *ngIf="addObservationListAgainst === 1">
            <div class="panel_sub_header">
                <span class="panel__header__title"> {{"Additional Observation List On Model" | translate | async}}</span>
                <span class="panel__header__title"> {{selectedModel?.Title}}</span>
            </div>
                <panel class="no-padding table-panel">
                    <table class="table table--full-width table--striped table--hover " >
                      <thead>
                        <tr>
                          <th >{{'Title' | translate | async}}</th>
                          <th>{{'Type' | translate | async}}</th>
                          <th>{{'Answer' | translate | async}}</th>
                          <th>{{'Disabled' | translate | async}}</th>
                          <th>{{'Edit' | translate | async}}</th>
                          <th><button mat-raised-button color="warn" (click)="addNewObservationListOnModel()">  {{"Add New" | translate | async}}  </button></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let model of modelLevelObservationList">
                          <td [@fadeIn] [attr.title]="model?.Title">{{ model.Title }}</td>
                          <td>  <div> {{ model.QuestionTypeName }} </div></td>
                          <td>  <div style="flex:1;display: flex;flex-direction: column;justify-content: center;">
                              <div *ngIf="model.QuestionTypeId == 1 ||model.QuestionTypeId == 2 || model.QuestionTypeId == 3 || model.QuestionTypeId == 5" style="flex:1;display: flex">
                                <i (click)="onClickEditAnswer(model)" class="material-icons button__icon"
                                  style="color:black;cursor: pointer;">comment</i>
                              </div>
                            </div></td>
                          <td  [@fadeIn] [attr.title]="model?.Disabled">{{model.Disabled ? "Disabled" : "Active"}}</td>
                          <td [@fadeIn] mat-stroked-button color="primary" ><button (click)="editObservation(model)" > {{"Edit Observation" | translate | async}}</button></td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </panel>

        </div>
        <div *ngIf="addObservationListAgainst === 2">
            <div>
                <div class="panel_sub_header">
                    <span class="panel__header__title"> {{"Additional Observation List On Family" | translate | async}}</span>
                    <span class="panel__header__title"> {{selectedFamily?.Title}}</span>
                </div>
                <panel class="no-padding table-panel">

                    <table class="table table--full-width table--striped table--hover" >
                      <thead>
                        <tr>
                          <th>{{'Title' | translate | async}}</th>
                          <th>{{'Type' | translate | async}}</th>
                          <th>{{'Answer' | translate | async}}</th>
                          <th>{{'Disabled' | translate | async}}</th>
                          <th>{{'Edit' | translate | async}}</th>
                          <th><button mat-raised-button color="warn" (click)="addNewObservationListOnFamily()">   {{"Add New" | translate | async}} </button></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let model of familyLevelObservationList">
                          <td [@fadeIn] [attr.title]="model?.Title">{{ model.Title }}</td>
                          <td>  <div> {{ model.QuestionTypeName }} </div></td>
                          <td> <div style="flex:1;display: flex;flex-direction: column;justify-content: center; ">
                              <div *ngIf="model.QuestionTypeId == 1 ||model.QuestionTypeId == 2 || model.QuestionTypeId == 3 || model.QuestionTypeId == 5" style="flex:1;display: flex">
                                <i (click)="onClickEditAnswer(model)" class="material-icons button__icon"
                                  style="color:black;cursor: pointer;">comment</i>
                              </div>
                            </div></td>
                          <td [@fadeIn] [attr.title]="model?.Disabled">{{model.Disabled ? "Disabled" : "Active"}}</td>
                          <td [@fadeIn] ><button mat-stroked-button color="primary" (click)="editObservation(model)" > {{"Edit Observation" | translate | async}}</button></td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </panel>
            </div>
        </div>


    </div>

</mat-card>
